import React from "react";
import LayoutHomepage from "../layout/LayoutHomepage";

import { Link } from "react-router-dom";
import Container from "../components/misc/Container";

// Icon Import
import FlashBrokoli from "../assets/images/brokoli.png";
import JagungManis from "../assets/images/sayur/buah/jagung.jpeg";
import Wortel from "../assets/images/sayur/akar/wortel.jpeg";
import Daging from "../assets/images/daging/sapi.jpeg";
import FlashSale from "../assets/icons/flash-sale.svg";

// Resep
import DaginAyam from "../assets/images/resep/daging-goreng.svg";
import SotoAyam from "../assets/images/resep/sate-ayam.svg";
import Tumis from "../assets/images/resep/tumis.svg";

import CategorySlide from "../components/Homepage/CategorySlide";
import BannerSlide from "../components/Homepage/BannerSlide";
import classnames from "classnames"

const Homepage = () => {
  const flashItem = [
    {
      imgSrc: FlashBrokoli,
      itemName: "Brokoli",
      imgAlt: "Brokoli",
      weight: "250gr",
      price: "Rp2500",
      discountPrice: "Rp5000",
      stock: "10",
      precentage: "20",
      route: "/flash",
    },
    {
      imgSrc: JagungManis,
      itemName: "Jagung",
      imgAlt: "Jagung",
      weight: "250gr",
      price: "Rp2500",
      discountPrice: "Rp5000",
      stock: "25",
      precentage: "60",
      route: "/flash",
    },
    {
      imgSrc: Wortel,
      itemName: "Wortel",
      imgAlt: "Wortel",
      weight: "250gr",
      price: "Rp6500",
      discountPrice: "Rp5500",
      stock: "5",
      precentage: "10",
      route: "/flash",
    },
    {
      imgSrc: Daging,
      itemName: "Daging",
      imgAlt: "Daging",
      weight: "250gr",
      price: "Rp20000",
      discountPrice: "Rp25000",
      stock: "10",
      precentage: "20",
      route: "/flash",
    },
    {
      imgSrc: FlashBrokoli,
      itemName: "Brokoli",
      imgAlt: "Brokoli",
      weight: "250gr",
      price: "Rp2500",
      discountPrice: "Rp5000",
      stock: "5",
      precentage: "40",
      route: "/flash",
    },
    {
      imgSrc: Wortel,
      itemName: "Wortel",
      imgAlt: "Wortel",
      weight: "250gr",
      price: "Rp6500",
      discountPrice: "Rp5500",
      stock: "25",
      precentage: "60",
      route: "/flash",
    },
    {
      imgSrc: Daging,
      itemName: "Daging",
      imgAlt: "Daging",
      weight: "250gr",
      price: "Rp20000",
      discountPrice: "Rp25000",
      stock: "8",
      precentage: "40",
      route: "/flash",
    },
  ];

  const recipeItem = [
    {
      imgSrc: Tumis,
      recipeHeadline: "Tumis Tahu hijau",
      route : "/tumis-tahu"
    },
    {
      imgSrc: SotoAyam,
      recipeHeadline: "Soto Ayam lamongan",
      route : "/soto-lamongan"
    },
    {
      imgSrc: DaginAyam,
      recipeHeadline: "Daging Goreng Krispi",
      route : "/daging-goreng"
    },
    {
      imgSrc: Tumis,
      recipeHeadline: "Tumis Tahu hijau",
      route : "/tumis-tahu"
    },
    {
      imgSrc: SotoAyam,
      recipeHeadline: "Soto Ayam lamongan",
      route : "/soto-lamongan"
    },
    {
      imgSrc: DaginAyam,
      recipeHeadline: "Daging Goreng Krispi",
      route : "/daging-goreng"
    },
  ];

  return (
    <LayoutHomepage>
      <div className="flex flex-col w-full mt-32">
        <Container>
          <div className="flex flex-col w-full relative mb-6">
            <div className="w-full my-4">
              <BannerSlide />
            </div>

            <div className="flex w-full my-2">
              <CategorySlide></CategorySlide>
            </div>
            {/* Slideshow End */}
            {/* Flash Sale */}
            {/* Chat Item */}
            <div className="absolute right-0 top-50"></div>
            {/* Chat ItemEnd  */}
            <div className="bg-white py-4 rounded my-4">
              <div className="flex px-8 border-b border-gray-100 pb-4">
                <div className="flex items-center">
                  <h5 className="text-lg text-font-gray tracking-0-22 mr-4">
                    Flash Deal
                  </h5>
                  <p className="text-sm text-basic-orange italic flex items-center font-semibold">
                    {" "}
                    <span className="mr-2">
                      <img src={FlashSale} className="h-4 w-4" alt="" />
                    </span>
                    08:06:00
                  </p>
                </div>
                <Link
                  to="/flash"
                  className="flex items-center ml-auto text-basic-orange px-4 py-2"
                >
                  Lihat Semua{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4 ml-2"
                    viewBox="0 0 13.74 23.333"
                  >
                    <g
                      id="Group_3986"
                      data-name="Group 3986"
                      transform="translate(2.121 2.121)"
                    >
                      <line
                        id="Line_452"
                        data-name="Line 452"
                        x2="13.431"
                        transform="translate(9.497 9.593) rotate(135)"
                        fill="none"
                        stroke="#f86542"
                        strokeLinecap="round"
                        strokeWidth="3"
                      />
                      <line
                        id="Line_453"
                        data-name="Line 453"
                        x2="13.431"
                        transform="translate(9.497 9.497) rotate(-135)"
                        fill="none"
                        stroke="#f86542"
                        strokeLinecap="round"
                        strokeWidth="3"
                      />
                    </g>
                  </svg>
                </Link>
              </div>
              <div className="flex px-8 py-4 justify-evenly">
                {/* Flash Item  */}
                {flashItem.map((item, index) => (
                  <div key={index} className="flex flex-col">
                    <Link to={item.route}>
                      <img src={item.imgSrc} alt="Brokoli" className="h-32" />
                    </Link>
                    <div className="flex justify-between items-center">
                      <p className="text-font-gray-light text-sm">
                        {item.itemName}
                      </p>
                      <p className="text-font-gray-light text-xs">
                        {item.weight}
                      </p>
                    </div>
                    <p className="text-font-gray mb-2 ">{item.price}</p>
                    <div className="relative pt-1">
                      <div className="overflow-hidden h-5 mb-4 text-xs flex rounded bg-gray-400 rounded-l-full rounded-r-full">
                        <div
                          style={{ width: item.precentage + "%" }}
                          className={classnames("shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center",{
                            "bg-orange-400" : 
                            item.precentage <= 50 && item.precentage > 20,
                            "bg-green-700" : 
                            item.precentage > 50,
                            "bg-red-700" : 
                            item.precentage <= 20,
                          }
                          )}
                        >
                          <p className="absolute py-2 mx-auto w-full">
                            {item.stock} Tersisa
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
                {/* End of flash item */}
              </div>
            </div>
            {/* Flash Sale End */}
            {/* Resep Sale */}
            <div className="bg-white py-4 rounded my-4">
              <div className="flex px-8 border-b border-gray-100 pb-4">
                <div className="flex items-center">
                  <h5 className="text-lg text-font-gray tracking-0-22 mr-4">
                    Resep
                  </h5>
                </div>
                <Link
                  to="/recipe"
                  className="flex items-center ml-auto text-basic-orange px-4 py-2"
                >
                  Lihat Semua{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4 ml-2"
                    viewBox="0 0 13.74 23.333"
                  >
                    <g
                      id="Group_3986"
                      data-name="Group 3986"
                      transform="translate(2.121 2.121)"
                    >
                      <line
                        id="Line_452"
                        data-name="Line 452"
                        x2="13.431"
                        transform="translate(9.497 9.593) rotate(135)"
                        fill="none"
                        stroke="#f86542"
                        strokeLinecap="round"
                        strokeWidth="3"
                      />
                      <line
                        id="Line_453"
                        data-name="Line 453"
                        x2="13.431"
                        transform="translate(9.497 9.497) rotate(-135)"
                        fill="none"
                        stroke="#f86542"
                        strokeLinecap="round"
                        strokeWidth="3"
                      />
                    </g>
                  </svg>
                </Link>
              </div>
              <div className="flex px-8 pt-6 pb-4 justify-evenly">
                {recipeItem.map((item, index) => (
                <div key={index} className="mx-3 bg-gray-100 w-2/12 rounded flex flex-col">
                  <Link to={item.route}>
                    <div
                      className="h-32  bg-cover"
                      style={{ backgroundImage: `url(${item.imgSrc})` }}
                    ></div>
                 </Link>
                  <p className="text-font-gray py-3 mx-auto">
                    {item.recipeHeadline}
                  </p>
                </div>
                ))}
              </div>
            </div>
            </div>
        </Container>
      </div>
    </LayoutHomepage>
  );
};

export default Homepage;
